import {
  ActiveSourcingChannelDetails,
  SourcingChannelStatus,
} from 'api-clients/monolith';
import { useCallback, useState } from 'react';

import { useChannelsStore } from '../use-channels-store';

export type SetReachPublisherStatus = (
  sourcingPurchaseId: string,
  publisherId: string,
  publisherStatus: SourcingChannelStatus,
) => void;

export const useReachChannels = () => {
  const activeCampaigns = useChannelsStore(s => s.activeCampaigns);
  const setActiveCampaignStatus = useChannelsStore(
    s => s.setActiveCampaignStatus,
  );

  const [reachPublishers, setReachPublishers] = useState<
    ActiveSourcingChannelDetails[]
  >([]);

  /**
   * When a publisher is toggled, we need to update the status of the reach campaign
   * If any one publisher is active and the reach campaign is stopped, set the reach campaign to active
   * If a publisher is stopped, check if any other publisher is active and if not, set the reach campaign to stopped
   */
  const setReachPublisherStatus = useCallback(
    (
      sourcingPurchaseId: string,
      publisherId: string,
      publisherStatus: SourcingChannelStatus,
    ) => {
      setReachPublishers(prevPublishers =>
        prevPublishers.map(publisher =>
          publisher.reach_campaign_id === publisherId
            ? { ...publisher, status: publisherStatus }
            : publisher,
        ),
      );

      const reachCampaign = activeCampaigns.find(
        campaign => campaign.sourcing_purchase_id === sourcingPurchaseId,
      );

      if (publisherStatus === 'active' && reachCampaign?.status === 'stopped') {
        setActiveCampaignStatus(sourcingPurchaseId, 'active');
      } else if (publisherStatus === 'stopped') {
        const isAnyPublisherActive = reachPublishers.some(publisher => {
          if (publisher.reach_campaign_id !== publisherId) {
            return publisher.status === 'active';
          }
          return false;
        });

        if (!isAnyPublisherActive) {
          setActiveCampaignStatus(sourcingPurchaseId, 'stopped');
        }
      }
    },
    [activeCampaigns, setActiveCampaignStatus, reachPublishers],
  );

  return {
    reachPublishers,
    setReachPublishers,
    setReachPublisherStatus,
  };
};
